import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import IconButton from '@mui/joy/IconButton';
import { useContext, useState, useEffect} from 'react';
import { ContextFromSelections,FetchedDataContext } from './Context';
import FormControl from '@mui/joy/FormControl';
import { Popover, Typography,Box} from '@mui/material';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';








export default function SelectRibbonWidth() {
  
  const [selectedData, setSelectedData] = useContext(ContextFromSelections);
  const [value, setValue] = useState(selectedData.ribbonWidth);
  const FetchedData = useContext(FetchedDataContext)
  const [RibbonColors, setRibbonColor] = useState([])
  
  

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
     handleClose();
    }, 2000); 
  };

  const handleClose = () => {
    setAnchorEl(null);
   
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;


  useEffect(() => {
    setRibbonColor(FetchedData.get("fetchedRibbonColors"))
    },[FetchedData]);

  

  return (
    
    
    <FormControl>
      <Typography fontSize={12} >Width</Typography>
    <Select
      size='sm'
      value={value}
      onClick={!(selectedData.ribbonColor) ? handleClick : null}
      placeholder="Select Width"
      onChange={(event, newValue) => {
        setValue(newValue);
        setSelectedData((data) => ({...data,ribbonWidth: newValue}));
        }}
      {...(value && {
      
        endDecorator: (
          <IconButton
            variant="plain"
            color="neutral"
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
            onClick={() => {
                setValue(null);
                setSelectedData((data) => ({...data,ribbonWidth: null}));
            }}
          >
            <CloseTwoToneIcon />
          </IconButton>
        ),
        indicator: null,
      })}
      sx={{ 
          width:{ xs: 160, sm: 170},
          height: 30,
          fontSize: 13,
          fontStyle: '500',
         }}
    >
    
    
    
      
      {(selectedData.ribbonColor && RibbonColors) ? (

      
        RibbonColors.map((obj) => {
        
          if (selectedData.ribbonColor === obj.color_name) {
            
            return (
              
              obj.ribbon_width.map((rwidth,index) => (
              <Box sx={{width:{ xs: 160, sm: 170},fontSize: 13,fontStyle: "500"}}>
              <Option key={index} value={rwidth}>
                {rwidth}
              </Option>
              </Box>
              
            )))
          }
          return null
          
          
        })
      )
      
      :
        <Box width={170}></Box>
        
      }
      </Select>
      <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
        >
    <Typography fontSize={14} sx={{ p: 1.5 }}>Choose color first!</Typography>
  </Popover>

  </FormControl>
  );
}


